import { ProductImage } from './manageImagesModal.types'

export const checkIfProductImagesHasChanges = (
  original: ProductImage[],
  modified: ProductImage[],
): boolean => {
  if (original.length !== modified.length) {
    return true
  }

  let hasChanges = false,
    i = 0
  while (!hasChanges && i < original.length) {
    // has reordered OR has assigned at least one image
    if (original[i].id !== modified[i].id || !!modified[i].unmatchedUploadId) {
      hasChanges = true
    }
    i++
  }

  return hasChanges
}
